<script setup lang="ts">
import {computed, inject, ref} from "vue";
import savedSearchesService from "@/services/saved-searches.service";

const savedSearch = inject('savedSearch');
const savedSearches = inject('savedSearches');
const saveSearchModal = inject('saveSearchModal');
const reloadSavedSearches = inject('reloadSavedSearches');
const manageSavedSearches = inject('manageSavedSearches');

const savedSearchFilter = ref('');
const dropdown = ref(null);

const flattenedSavedSearches = computed(() => savedSearches.value.reduce((acc, group) => {
    acc.push(...group.items);
    return acc;
}, []));

const filteredSavedSearches = computed(() => flattenedSavedSearches.value.filter(item => !savedSearchFilter.value || item.name.toLowerCase().includes(savedSearchFilter.value.toLowerCase())));

async function deleteSavedSearch(id) {
    if (confirm("Delete Search?")) {
        await savedSearchesService.deleteSearch(id)
        reloadSavedSearches();
    }
}

</script>

<template>
    <div v-if="flattenedSavedSearches.length" class="dropdown--saved">
        <b-dropdown id="dropdown-form" :text="savedSearch ? savedSearch.name : 'Saved'" ref="dropdown" class="">
            <b-dropdown-form class="dropdown--saved__form">
                <div class="d-flex align-items-center mb-4">
                    <b-form-group>
                        <b-form-input
                            v-model="savedSearchFilter"
                            type="search"
                            placeholder="Search"
                            class="dropdown--saved__search"
                        />

                    </b-form-group>

                    <a @click="manageSavedSearches" class="dropdown--saved__settings"></a>
                </div>
            </b-dropdown-form>

            <li v-for="savedSearchItem in filteredSavedSearches" :key="savedSearchItem.id">
                <a @click="() => {savedSearch = savedSearchItem; dropdown.hide()}">{{savedSearchItem.name}}</a>
                <a @click="saveSearchModal.openSave(savedSearchItem.id)" class="link-edit"></a>
                <a @click="deleteSavedSearch(savedSearchItem.id)" class="link-delete-light"></a>
            </li>
        </b-dropdown>
    </div>
</template>

<style scoped>

</style>
